// Native iOS (Capacitor WKWebView) session handling. Cross-site cookies are
// blocked in WKWebView, so the app keeps the session token and sends a Bearer header.
const KEY = "metier_session_token";

export const NATIVE_AUTH_URL_PREFIX = "com.workmetier.app://auth";

export function isNative() {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch { return false; }
}

export function getToken() {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
}

export function setToken(t) {
  try { if (t) window.localStorage.setItem(KEY, t); } catch { /* storage unavailable */ }
}

export function clearToken() {
  try { window.localStorage.removeItem(KEY); } catch { /* storage unavailable */ }
}
